import { putProduct } from "../fetch/fetch.item";
import { useContext } from "react";
import { SubmitContext } from "../context/context.submit";
import { useSWRConfig } from "swr";
import { API_GET_ITEM } from "../fetch/const.routes";
import { ItemStatusType, ItemType } from "../types/Item.ts";

export function useItemForm(itemId: string) {
  const { loading, setError, initSubmit, finishSubmit, error } =
    useContext(SubmitContext);
  const { mutate } = useSWRConfig();

  const setStatus = async (item: ItemType, status: ItemStatusType) => {
    if (!initSubmit()) return false;
    const res = await putProduct({ ...item, status: status });
    if (!res.ok) {
      setError(res.error);
      return finishSubmit(false);
    }
    await mutate(API_GET_ITEM(itemId), res.value);
    return finishSubmit(false);
  };
  return {
    loading: loading,
    error: error,
    setStatus: setStatus,
  };
}
